import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Video_Overlays/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaPerm';
import VideoOverlayTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Video_Overlays/videoOverlayTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Multimedia Menü // Video Overlays",
  "path": "/Web_User_Interface/1440p_Serie/Multimedia/Video_Overlays/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Stellen Sie den Namen Ihrer Kamera ein und zeigen Sie sie im Videostream an. Fügen Sie dem Video einen Zeitstempel hinzu.",
  "image": "./WebUI_1440p_SearchThumb_Multimedia_Overlays.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Multimedia_Overlays.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Multimedia Menü // Video Overlays' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Stellen Sie den Namen Ihrer Kamera ein und zeigen Sie sie im Videostream an. Fügen Sie dem Video einen Zeitstempel hinzu.' image='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Overlays.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Multimedia_Overlays.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Multimedia/Video_Overlays/' locationFR='/fr/Web_User_Interface/1440p_Series/Multimedia/Video_Overlays/' crumbLabel="Video Overlays" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "multimedia-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#multimedia-men%C3%BC",
        "aria-label": "multimedia menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Multimedia Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/0a23223b88635a31726e2b0ce5ca101e/aa61c/1440p_Settings_Multimedia_Overlays.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "47.39130434782609%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACDUlEQVQoz2XST2vTcBzH8T4VkXZtk+nqVLY2TfNL0jTJmrokTf+GWadORdhAxQkVnYLgSSbMm9PNSxWZOwiKl+FBL+JB8AH4UN7a1m6Chw+/24s3X34JSZLIZrNIkkzq+DHs+CbnH76h039Ju797uM7dV3T6u0Tr2zTvPKf3YIAT30KZz5PLnSGblZHlEySOQIlkMoVQC7RCj8CzCbwKYc2mXnNYsDRsQx29Fb2IpSssujXKwkHXTYRmUcirJDKZzAgcLplMYhgmnW5M1GgS1iP8IBzNXahScVwct4ptO9iLTbrNmMaihS401KLO/JwyBieVY9AgjmPa7TZRFOH7PkEQ4Do2FVPHNA1E2UR4LXrnfS4uldC1MVjIF48Kh2gqlRqBEywMw7+gj+c3sf0urlOjaRgElsf1CyG9hqBULFHWNYqFfwonoBCCer1+WDZEz9WqeL11mv1tlpfX2XIWeFR22VxbZeNSG0XJYxmC/LxCYnK/4dLpNJIsMXtqFl2YiOH0MlbZ5t7tVTYfbzB4t8f+2x12nj3lw842T652MUWRkirGN5zUDUuHm5qaQpan0VQTxzRZaVR5cf8Kvz4P+PH1gG8HH/ny/jXf9wf8/LTH1mqL5YZFSTVQCur/hZlMegTPnMyhzs3iqmdpuRqX2wE31q4RRz5Vx6FTdVhZ6lBT59CV08zM5Jj+8w9/AygGVeJpj7mHAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/0a23223b88635a31726e2b0ce5ca101e/e4706/1440p_Settings_Multimedia_Overlays.avif 230w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/d1af7/1440p_Settings_Multimedia_Overlays.avif 460w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/7f308/1440p_Settings_Multimedia_Overlays.avif 920w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/2cb71/1440p_Settings_Multimedia_Overlays.avif 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/0a23223b88635a31726e2b0ce5ca101e/a0b58/1440p_Settings_Multimedia_Overlays.webp 230w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/bc10c/1440p_Settings_Multimedia_Overlays.webp 460w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/966d8/1440p_Settings_Multimedia_Overlays.webp 920w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/fa9eb/1440p_Settings_Multimedia_Overlays.webp 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/0a23223b88635a31726e2b0ce5ca101e/81c8e/1440p_Settings_Multimedia_Overlays.png 230w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/08a84/1440p_Settings_Multimedia_Overlays.png 460w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/c0255/1440p_Settings_Multimedia_Overlays.png 920w", "/de/static/0a23223b88635a31726e2b0ce5ca101e/aa61c/1440p_Settings_Multimedia_Overlays.png 1065w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/0a23223b88635a31726e2b0ce5ca101e/c0255/1440p_Settings_Multimedia_Overlays.png",
              "alt": "Web User Interface - 1440p Series - Multimedia Video Overlays",
              "title": "Web User Interface - 1440p Series - Multimedia Video Overlays",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoOverlayTable mdxType="VideoOverlayTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      